// extracted by mini-css-extract-plugin
export default {"table":"DocumentsTable-module__table__UtCbR","link":"DocumentsTable-module__link__ZJeoq"};